import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import TaskAltRoundedIcon from '@mui/icons-material/TaskAltRounded';
import Button from '@ui-elements/Button';
import { PALETTE } from '~/assets/styles/base';
import { ROUTES } from '~/constants/routes';

const StyledBox = styled.div`
  background: ${PALETTE.white};
  width: 636px;
  border: 1px solid ${PALETTE.border.frame};
  margin: 55px auto 0;
  padding: 55px 0 72px;
  text-align: center;
  white-space: pre-line;
`;

const StyledIcon = styled(TaskAltRoundedIcon)`
  color: ${PALETTE.text.primary};
  font-size: 46px;
`;

type TitleProps = {
  component: string;
};
const Title = styled(Typography)<TitleProps>`
  color: ${PALETTE.text.primary};
  margin: 17px 0 32px;
`;

const Desc = styled(Typography)`
  line-height: 1.6;
  white-space: pre-line;
`;

const StyledButton = styled(Button)`
  display: block;
  margin: 32px auto 0;
`;

// 自主退会完了画面
const WithdrawCompleted = () => {
  const { t } = useTranslation();

  return (
    <StyledBox data-testid="WithdrawCompleted-box">
      <StyledIcon />
      <Title variant="title1" component="p" data-testid="WithdrawCompleted-title">
        {t('withdrawCompleted.title')}
      </Title>
      <Desc variant="bodyDefault" data-testid="WithdrawCompleted-desc">
        {t('withdrawCompleted.desc')}
      </Desc>
      <StyledButton
        size="large"
        onClick={() => {
          window.location.href = ROUTES.COMMON.GMO_RESEARCH_TOP;
        }}
        dataTestId="withdrawCompletedToTop"
      >
        {t('withdrawCompleted.toTop')}
      </StyledButton>
    </StyledBox>
  );
};

export default WithdrawCompleted;
